//
// Mouse button indices as reported by {@link MouseEvent.button}.
// These identify which button triggered a mousedown/mouseup event.
//
export const MOUSE_BUTTON_LEFT = 0;
export const MOUSE_BUTTON_MIDDLE = 1;
export const MOUSE_BUTTON_RIGHT = 2;

//
// Mouse button bitmask values as reported by {@link MouseEvent.buttons}.
// These indicate which buttons are currently held during any mouse event.
// A value of 0 means no buttons are pressed.
//
export const MOUSE_BUTTONS_NONE = 0;
export const MOUSE_BUTTONS_LEFT_MASK = 1;
export const MOUSE_BUTTONS_MIDDLE_MASK = 4;
export const MOUSE_BUTTONS_RIGHT_MASK = 2;

/** The {@link MouseEvent.buttons} bit of a {@link MouseEvent.button} index. */
export function buttonsMaskOf(button: number): number {
    switch (button) {
        case MOUSE_BUTTON_LEFT:
            return MOUSE_BUTTONS_LEFT_MASK;
        case MOUSE_BUTTON_MIDDLE:
            return MOUSE_BUTTONS_MIDDLE_MASK;
        case MOUSE_BUTTON_RIGHT:
            return MOUSE_BUTTONS_RIGHT_MASK;
        default:
            // Back, forward and any further button keep their index order.
            return 1 << button;
    }
}
